import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private http: HttpClient) {
  }

  sendPayment(command) {
    return this.http.post('https://cmsforms.rootor.eu/payment_dev.php', command);
  }
}
